import style from './style.module.css';

const Col = ({children}) => {
    return(
        <div className={style.col}>
            {children}
        </div>
    )
}

export default Col;